import React, { useState, useEffect, useRef } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import Select from "react-select";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import {
  FaFolder,
  FaFile,
  FaArrowLeft,
  FaHome,
  FaListUl,
  FaTimes,
  FaCopy,
  FaCalendarAlt,
  FaSyncAlt,
  FaCheck,
} from "react-icons/fa";
import { IoMdShareAlt } from "react-icons/io";
import { MdDownload } from "react-icons/md";
import { IoGridOutline } from "react-icons/io5";
import { useLocation } from "react-router-dom";
import awsService from "../services/awsService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import shareService from "../services/shareService";
import { useStateContext } from "../contexts/ContextProvider";
import "react-datepicker/dist/react-datepicker.css";
import { CiFileOn } from "react-icons/ci";
import { Tooltip } from "react-tooltip";
import { FaRegFileImage } from "react-icons/fa6";
import tenantService from "../services/tenantService";
import { FaUsers } from "react-icons/fa";
import { GrStorage } from "react-icons/gr";
import { subDays } from "date-fns";
import Loading from "../components/Loading";
import SharedLinks from "../components/SharedLinks";
import FileViewer from "../components/FileViewer";
import Rename from "../components/Rename";
import DeleteConfirmationModal from "../components/DeleteConfirmationModal";

const S3FileManager = () => {
  const [loading, setLoading] = useState(false);
  const [uploading, setupLoading] = useState(false);
  const { currentColor, currentMode } = useStateContext();
  const [files, setFiles] = useState([]);
  const [currentPrefix, setCurrentPrefix] = useState("");
  const [viewType, setViewType] = useState("grid");
  const location = useLocation();
  const [awsId, setAwsId] = useState([]);
  const [userId, setuserId] = useState("");
  const [bucketName, setBucketName] = useState([]);
  const [writeAccess, setWriteAccess] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [shareEmails, setShareEmails] = useState([]);
  const [expiryDate, setExpiryDate] = useState(new Date());
  const [itemToShare, setItemToShare] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showShareLinkModal, setShowShareLinkModal] = useState(false);
  const [shareLink, setShareLink] = useState("");
  const [sharePassword, setSharePassword] = useState("");
  const [showSharebutton, setshowSharebutton] = useState(false);
  const [tenants, setTenants] = useState([]);
  const [buckets, setBuckets] = useState([]);
  const [showTenant, setshowTenant] = useState(true);
  const [showBucket, setshowBucket] = useState(false);
  const [showFiles, setshowFiles] = useState(false);
  const [currentView, setCurrentView] = useState("tenant");
  const [selectedTenant, SetSelectedTenant] = useState({});
  const [selectedBucket, setSelectedBucket] = useState({});
  const [previousprefix, setPreviousPrefix] = useState("");
  const [dropdownIndex, setDropdownIndex] = useState(null);
  const [ItemId, setItemId] = useState("");
  const [itemIdStack, setItemIdStack] = useState([]);
  const [createFolder, setCreateFolder] = useState(false);
  const [folderModal, setFolderModal] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [sharedLink, setSharedLink] = useState([]);
  const [showSharedLink, setShowSharedLink] = useState(false);

  const [selectedOptions, setSelectedOptions] = useState([]);

  const [copiedLink, setCopiedLink] = useState(false);
  const [copiedPassword, setCopiedPassword] = useState(false);
  const [fileModal, setFileModal] = useState(false);
  const [fileData, setFileData] = useState(null);
  const [fileType, setFileType] = useState("");
  const dropdownRef = useRef(null);
  const [showCopyReplaceModal, setShowCopyReplaceModal] = useState(false);
  const [fileContent, setFileContent] = useState(""); // Add this if you need to set the filename dynamically
  const [copyFilename, setcopyFilename] = useState(""); // Add this if you need to set the filename dynamically
  const [renameModal, setShowRenameModal] = useState(false);
  const [renameFileModal, setShowRenameFileModal] = useState(false);
  const [renameFolderName, setRenameFolderName] = useState("");
  const [itemRename, setitemRename] = useState({});
  const [fileDelete, setFileDelete] = useState(false);
  const [itemDelete, setItemDelete] = useState({});

  useEffect(() => {
    // Function to handle clicks outside of the dropdown
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownIndex(null); // Close the dropdown
      }
    };

    // Add event listener for clicks
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setDropdownIndex]);

  const options = [
    { value: "viewOnlyAccess", label: "View Only" },
    { value: "downloadAccess", label: "Download" },
    { value: "uploadAccess", label: "Upload" },
  ];
  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #d1d5db", // Tailwind's gray-300
      borderRadius: "0.375rem", // Tailwind's rounded-lg
      padding: "0.2rem", // Tailwind's p-2
    }),
    multiValue: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }),
  };

  const toggleDropdown = (index) => {
    console.log(index);
    if (dropdownIndex === index) {
      setDropdownIndex(null); // Close dropdown if it's already open
    } else {
      setDropdownIndex(index); // Open the clicked dropdown
    }
  };

  const fetchData = async (prefix, bucketName, item) => {
    try {
      console.log(!item?._id);
      if (item?._id == "") {
        setWriteAccess(false);
        setCreateFolder(true);
      } else {
        setWriteAccess(true);
        setCreateFolder(false);
      }
      console.log(
        "fetchdata--------",
        typeof prefix,
        prefix,
        "----------",
        bucketName,
        "-------",
        item
      );
      setLoading(true);

      console.log(prefix);
      if (prefix == "") {
        prefix = "";
      } else if (item?.pre) {
        // if (currentPrefix !== "") {

        prefix = `${item.pre}`;
        // } else {
        //   prefix = `${prefix}`;
        // }
      }

      // console.log(`${currentPrefix}/${prefix}`);
      let data = {
        // awsId,
        bucketName: bucketName.bucketName,
        // prefix: `${prefix}`,
        _id: item?._id || "",
      };
      console.log("Fetching data with:", data);
      // const response = await awsService.getavailablefolders(data);
      if (item?._id !== undefined || item?._id == "") {
        const response = await awsService.getdblistData(data);
        console.log("Response received:", response.data[0]);

        if (prefix === "" || !item?._id) {
          setshowSharebutton(false);
          // console.log(allowedFolders);

          const folders = response?.data[0]?.fileData?.filter(
            (item) => item.Type == "folder"
          );

          console.log("only folderss-------", folders);
          // await fetchData(folders[0].pre, bucketName, {
          //   _id: response?.data[0]?.fileData[0]?._id,
          // });
          let filteredFolders = response?.data[0]?.fileData
            // .filter((o) => allowedFolders.includes(folders[0]?.pre))
            .map((o) => {
              if (o.Type !== "folder") {
                o["newName"] = o.filename.split("/").pop();
              } else {
                o["newName"] = o.Prefix;
              }
              return o;
            });
          console.log(filteredFolders, "sorted");
          const sortedData = filteredFolders.sort((a, b) => {
            if (a.Type === "folder" && b.Type !== "folder") {
              return -1;
            }
            if (a.Type !== "folder" && b.Type === "folder") {
              return 1;
            }
            return 0;
          });
          console.log(sortedData);

          setFiles(sortedData);
          setWriteAccess(false);
          // const folders = response?.data[0]?.fileData?.filter(
          //   (item) => item.type === "folder"
          // );

          setCurrentPrefix(
            response?.data[0]?.ParentFolder == "/"
              ? ""
              : response?.data[0]?.ParentFolder == "/"
          );
        } else {
          setshowSharebutton(true);
          const sortedData = response?.data[0]?.fileData?.sort((a, b) => {
            if (a.Type === "folder" && b.Type !== "folder") {
              return -1;
            }
            if (a.Type !== "folder" && b.Type === "folder") {
              return 1;
            }
            return 0;
          });
          console.log(sortedData);
          let newData = sortedData?.map((o) => {
            if (o.Type !== "folder") {
              o["newName"] = o.filename.split("/").pop();
            } else {
              o["newName"] = o.Prefix;
            }
            return o;
          });
          console.log(newData);

          setFiles(newData);
          // setWriteAccess(true);
          console.log(response.data[0].ParentFolder);
          setCurrentPrefix(response?.data[0]?.ParentFolder || prefix);
        }
        setLoading(false);
        setupLoading(false);
      } else {
        // setshowFiles(false);
        // setshowBucket(false);
        // setshowTenant(true);
        // setCurrentView("tenant");
        setLoading(false);
        setupLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
      setupLoading(false);
    }
  };

  const fetcTenant = async () => {
    const userDetails = localStorage.getItem("userData");
    const userid = JSON.parse(userDetails)?._id;
    setuserId(userid);
    let tenants = await tenantService.gettenantsbyuser({ user: userid });
    console.log(tenants);
    setTenants(tenants);
  };
  useEffect(async () => {
    await fetcTenant();
    // document.addEventListener("mousedown", handleClickOutside);
    // return () => {
    //   document.removeEventListener("mousedown", handleClickOutside);
    // };
  }, []);

  const handleFolderClick = (folderKey, pf, item) => {
    setWriteAccess(true);
    setDropdownIndex(null);

    console.log(folderKey, "first", pf, item);
    setItemIdStack((prevStack) => [...prevStack, ItemId]);
    // Set the new ItemId
    setItemId(item._id);
    setPreviousPrefix(folderKey);
    fetchData(folderKey, pf, item);
    // setCurrentView("file");
  };

  const toggleGridView = () => {
    console.log("first");
    setViewType("grid");
  };

  const toggleListView = () => {
    setViewType("list");
  };

  const handleHomeClick = () => {
    setCreateFolder(false);
    setViewType("grid");
    setshowTenant(true);
    setshowBucket(false);
    setshowFiles(false);
    setFiles([]);
    setCurrentView("tenant");
    setCurrentPrefix("");
    setSelectedBucket(null);
    setWriteAccess(false);
  };

  const handleCreateFolder = async () => {
    const userDetails = localStorage.getItem("userData");
    const userId = JSON.parse(userDetails)._id;
    setLoading(true);
    if (folderName) {
      const under_folder_name = replaceSpacesWithUnderscores(folderName);
      console.log(currentPrefix, "---------------------current-==-prefix---");
      const newFolderKey = currentPrefix + under_folder_name + "/";
      try {
        let data = {
          folderKey: newFolderKey,
          bucketName: bucketName,
          awsId: awsId,
          userId: userId,
        };
        setCreateFolder(false);
        setShowModal(false);
        setFolderModal(false);
        console.log(data, "prefix");
        const folder_creation = await awsService.createFolder(data);
        setFolderName("");
        console.log(folder_creation);
        if (typeof folder_creation.data == "string") {
          setLoading(false);
          setFolderName("");
          setShowRenameModal(true);
        } else if (folder_creation && folder_creation.success) {
          toast.success("Folder created successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        setTimeout(async () => {
          await fetchData(currentPrefix, selectedBucket, { _id: ItemId });
        }, 4000);
      } catch (error) {
        console.error("Error creating folder:", error);
      }
    }
  };

  const handleFileUpload = async (e) => {
    setLoading(true);
    const file = e.target.files[0];
    console.log(file.name, "----file-name---");
    console.log(file);
    setFileContent(file);
    let newName = getFileNameWithoutExtension(file.name);
    setcopyFilename(newName);

    const formData = new FormData();
    formData.append("filename", file.name);
    formData.append("prefix", currentPrefix);
    formData.append("awsId", awsId);
    formData.append("bucketName", bucketName);

    try {
      let url = await awsService.uploadFile(formData);
      if (typeof url === "string") {
        setLoading(false);

        setShowCopyReplaceModal(true);
      } else {
        const response2 = await axios.put(url.imageData, file, {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            updateProgress(percentCompleted);
          },
        });
        if (response2.status === 200) {
          console.log("File uploaded successfully");
          // let url = awsService.updateDBUpload({
          //   prefix: currentPrefix,
          //   awsId,
          //   bucketName,
          // });
          // if (url) {
          //   setLoading(false);
          // }
          setShowModal(false);
          setLoading(true);
          setTimeout(async () => {
            await fetchData(currentPrefix, selectedBucket, { _id: ItemId });
          }, 5000);

          console.log("dbupdated", "-------------------");
        } else {
          setLoading(false);
          console.error(
            "Failed to upload file, status code:",
            response2.status
          );
        }
      }

      // fetchData(currentPrefix);
    } catch (error) {
      setLoading(false);
      console.error("Error uploading file:", error);
    }
  };
  const handleFileUploadCopy = async (e) => {
    setLoading(true);
    const file = e;
    console.log(file);
    setFileContent(file);
    let neName = getFileNameWithoutExtension(file.name);
    setcopyFilename(neName);
    const formData = new FormData();
    formData.append("filename", file.name);
    formData.append("prefix", currentPrefix);
    formData.append("awsId", awsId);
    formData.append("bucketName", bucketName);

    try {
      let url = await awsService.uploadFile(formData);
      if (typeof url === "string") {
        setLoading(false);

        setShowCopyReplaceModal(true);
      } else {
        const response2 = await axios.put(url.imageData, file, {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            updateProgress(percentCompleted);
          },
        });
        if (response2.status === 200) {
          console.log("File uploaded successfully");
          // let url = awsService.updateDBUpload({
          //   prefix: currentPrefix,
          //   awsId,
          //   bucketName,
          // });
          // if (url) {
          //   setLoading(false);
          // }
          setShowModal(false);
          setLoading(true);
          setTimeout(async () => {
            await fetchData(currentPrefix, selectedBucket, { _id: ItemId });
          }, 5000);

          console.log("dbupdated", "-------------------");
        } else {
          setLoading(false);
          console.error(
            "Failed to upload file, status code:",
            response2.status
          );
        }
      }

      // fetchData(currentPrefix);
    } catch (error) {
      setLoading(false);
      console.error("Error uploading file:", error);
    }
  };
  const updateProgress = (percentage) => {
    console.log(`Upload Progress: ${percentage}% `);
    if (percentage < 100) {
      if (!loading) {
        setupLoading(true);
      }
    } else {
      setupLoading(false);
    }
  };

  const handleOptionsClick = (e, item) => {
    e.stopPropagation();
    const updatedFiles = files.map((file) =>
      file.Prefix === item.Prefix
        ? { ...file, showOptions: !file.showOptions }
        : file
    );
    setFiles(updatedFiles);
  };
  const handleShare = async (item) => {
    setDropdownIndex(null);
    console.log(item);
    try {
      const alreadyExists = await shareService.sharedlist({
        bucketName,
        item,
      });
      setSharedLink(alreadyExists);

      setItemToShare(item);
      setShowShareModal(true);
    } catch (error) {
      console.log(error);
    }
  };
  const getFileNameWithoutExtension = (fileName) => {
    console.log(fileName);
    const parts = fileName.split(".");
    parts.pop(); // Remove the extension
    return parts.join("."); // Rejoin the remaining parts
  };
  const handleReplaceUpload = async () => {
    setLoading(true);
    const file = fileContent;
    console.log(file);
    setFileContent(file);
    let newName = getFileNameWithoutExtension(file.name);
    setcopyFilename(newName);
    const formData = new FormData();
    formData.append("filename", file.name);
    formData.append("prefix", currentPrefix);
    formData.append("awsId", awsId);
    formData.append("bucketName", bucketName);

    try {
      let url = await awsService.replaceFile(formData);
      const response2 = await axios.put(url.imageData, file, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          updateProgress(percentCompleted);
        },
      });
      if (response2.status === 200) {
        console.log("File uploaded successfully");
        // let url = awsService.updateDBUpload({
        //   prefix: currentPrefix,
        //   awsId,
        //   bucketName,
        // });
        // if (url) {
        //   setLoading(false);
        // }
        setShowModal(false);
        setLoading(true);
        setTimeout(async () => {
          await fetchData(currentPrefix, selectedBucket, { _id: ItemId });
        }, 5000);

        console.log("dbupdated", "-------------------");
      } else {
        setLoading(false);
        console.error("Failed to upload file, status code:", response2.status);
      }

      // fetchData(currentPrefix);
    } catch (error) {
      setLoading(false);
      console.error("Error uploading file:", error);
    }
  };
  const handleCopyUpload = async () => {
    console.log(fileContent, copyFilename);
    // Assuming fileContent is an instance of File
    const originalFile = fileContent; // Replace fileContent with the actual File object
    // Get the original file name without the extension
    const originalFileName = originalFile.name
      .split(".")
      .slice(0, -1)
      .join(".");

    console.log(originalFileName, "oroginal file");
    // Get the file extension
    const fileExtension = originalFile.name.split(".").pop();
    console.log(fileExtension, "fileExtension");
    const newName = copyFilename;

    const timestamp = Date.now();

    // Create the new file name
    const newFileName = `${newName}.${fileExtension}`;
    console.log(newFileName, newName);

    const newFile = new File([originalFile], newFileName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });
    console.log(newFile);
    handleFileUploadCopy(newFile);
  };

  const handleDownload = async (item) => {
    console.log(`Download: ${item.Key || item.Prefix}`, item);
    setDropdownIndex(null);

    // Form data to send to the server
    const formData = {
      awsId,
      bucketName,
      currentPrefix,
      id: item._id, // Added to specify the file to download
    };

    try {
      if (item?.Type == "file") {
        setDropdownIndex(null);
        setLoading(true);
        // Fetch the presigned URL for downloading the file
        let url = await awsService.downloadFile(formData);

        // Download the file using Axios
        const response = await axios.get(url, {
          responseType: "blob", // This ensures the response is treated as a binary file
          // onDownloadProgress: (progressEvent) => {
          //   const percentCompleted = Math.round(
          //     (progressEvent.loaded * 100) / progressEvent.total
          //   );
          //   updateProgress(percentCompleted); // Update progress here
          // },
        });

        if (response.status === 200) {
          console.log("File downloaded successfully");

          // Create a URL for the downloaded file
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data])
          );

          // Create a link element to trigger the download
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", item.newName);
          document.body.appendChild(link);
          link.click();
          setLoading(false);
          setupLoading(false);

          document.body.removeChild(link);
        } else {
          console.error(
            "Failed to download file, status code:",
            response.status
          );
        }
      } else if (item.Type == "folder") {
        setLoading(true);
        let response = await awsService.downloadFolder(formData);
        setDropdownIndex(null);

        if (response) {
          const url = window.URL.createObjectURL(response);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${item.Prefix}.zip`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);

          setLoading(false);
          toast.success("file Downloaded!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    } catch (error) {
      setLoading(false);
      setDropdownIndex(null);
      console.error("Error downloading file:", error);
    }
  };
  const handleDownloadlink = async (item) => {
    setDropdownIndex(null);

    console.log(`Download: ${item.Key || item.Prefix}`);

    // Form data to send to the server
    const formData = {
      awsId,
      id: item._id,
      bucketName,
      currentPrefix,
      fileKey: item.Key || item.Prefix, // Added to specify the file to download
    };

    try {
      // Fetch the presigned URL for downloading the file
      let url = await awsService.downloadFile(formData);
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url);
      } else {
        // Use the 'out of viewport hidden text area' trick
        const textArea = document.createElement("textarea");
        textArea.value = url;

        // Move textarea out of the viewport so it's not visible
        textArea.style.position = "absolute";
        textArea.style.left = "-999999px";

        document.body.prepend(textArea);
        textArea.select();

        try {
          document.execCommand("copy");
        } catch (error) {
          console.error(error);
        } finally {
          textArea.remove();
        }
      }
      setDropdownIndex(null);

      console.log("URL copied to clipboard:", url);

      // Display a toast notification
      // toast.success('Download link copied to clipboard!');
      toast.success("Download link copied to clipboard!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      setDropdownIndex(null);
      console.error("Error downloading file:", error);
    }
  };

  const handleRenameFile = async (item) => {
    try {
      console.log(item);
      const fielname = getFileNameWithoutExtension(item.newName);
      setFolderName(fielname);
      setitemRename(item);
      setShowRenameFileModal(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteFileModal = async (item) => {
    try {
      setItemDelete(item);
      setFileDelete(true);
    } catch (error) {}
  };

  const handlefileRenameSubmit = async () => {
    try {
      setLoading(true);
      if (itemRename.Type == "file") {
        const fileExtension = itemRename.newName.split(".").pop();
        const formData = {
          awsId,
          bucketName,
          currentPrefix,
          id: itemRename._id,
          newname: `${folderName}.${fileExtension}`,
        };
        console.log(formData);
        const renameFile = await awsService.reanameFile(formData);

        if (renameFile.success) {
          toast.success(
            renameFile?.data?.message || "File renamed Successfully",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );

          setTimeout(async () => {
            await fetchData(currentPrefix, selectedBucket, { _id: ItemId });
          }, 5000);
        }

        setFolderName("");
        setitemRename({});
      } else if (itemRename.Type == "folder") {
        const formData = {
          awsId,
          bucketName,
          currentPrefix,
          id: itemRename._id,
          newname: `${folderName}`,
        };
        console.log(formData);
        const renameFile = await awsService.reanameFolder(formData);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message || "Error renaming file", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      console.log(error);
    }
  };
  const handleFileDelete = async () => {
    try {
      setLoading(true);
      const formData = {
        awsId,
        bucketName,
        currentPrefix,
        id: itemDelete._id,
      };
      console.log(formData);
      const deleteFile = await awsService.deleteFile(formData);
      console.log(deleteFile);

      if (deleteFile.success) {
        setFolderName("");
        setItemDelete({});

        setTimeout(async () => {
          await fetchData(currentPrefix, selectedBucket, { _id: ItemId });
        }, 5000);

        toast.success(
          deleteFile?.data?.message || "File Deleted Successfully",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
    } catch (error) {
      setLoading(false);
      console.log(error?.response?.data?.message);
      toast.error(error?.response?.data?.message || "Error deleting File", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  const handleCloseFileDelete = async () => {
    try {
      setItemDelete({});
      setFileDelete(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleShareSubmit = async (shareDetails) => {
    console.log(shareDetails, itemToShare);

    if (shareDetails.length > 0 && itemToShare) {
      try {
        const response = await shareService.addshare({
          shareDetails,
          item: itemToShare,
          awsId,
          bucketName,
          userId,
          expiryDate,
          TenantID: selectedTenant._id,
        });
        console.log(response);
        let url =
          window.location.origin + "/share/" + response.shareData.token.key;
        // window.location.origin + "/getfile/" + response.shareData.token;
        setDropdownIndex(null);

        console.log(url);
        setShareLink(url);
        // setShareEmailsList(response.credentials);
        setSharePassword(response.shareData.password);
        setShowShareLinkModal(true);
      } catch (error) {
        console.error("Error generating share link:", error);
      }
      setShowShareModal(false);
      setShareEmails([]);
      setExpiryDate(new Date());
    }
  };
  const onSubmit = async () => {
    await handleShareSubmit(shareDetails);
    setShowShareModal(false);
  };

  const [selectedEmail, setSelectedEmail] = useState("");
  const [copied, setCopied] = useState(false);
  const copyToClipboard = (text, copyParam) => {
    // navigator.clipboard.writeText(text);
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text);
      if (copyParam == "link") {
        setCopiedLink(true);
        setTimeout(() => {
          setCopiedLink(false);
        }, 2000);
      }
      if (copyParam == "password") {
        setCopiedPassword(true);
        setTimeout(() => {
          setCopiedPassword(false);
        }, 2000);
      }
    } else {
      // Use the 'out of viewport hidden text area' trick
      const textArea = document.createElement("textarea");
      textArea.value = text;

      // Move textarea out of the viewport so it's not visible
      textArea.style.position = "absolute";
      textArea.style.left = "-999999px";

      document.body.prepend(textArea);
      textArea.select();

      try {
        document.execCommand("copy");
        if (copyParam == "link") {
          setCopiedLink(true);
          setTimeout(() => {
            setCopiedLink(false);
          }, 2000);
        }
        if (copyParam == "password") {
          setCopiedPassword(true);
          setTimeout(() => {
            setCopiedPassword(false);
          }, 2000);
        }
      } catch (error) {
        console.error(error);
      } finally {
        textArea.remove();
      }
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const [shareDetails, setShareDetails] = useState([
    {
      expiryDate: new Date(),
      uploadAccess: false,
      downloadAccess: true,
      viewOnlyAccess: true,
      withoutPassword: false,
    },
  ]);
  const handleExpiryDateChange = (index, date) => {
    const newShareDetails = [...shareDetails];
    newShareDetails[index].expiryDate = date;
    setShareDetails(newShareDetails);
  };
  const handlePasswordProtectionChange = (index, isChecked) => {
    const newShareDetails = [...shareDetails];
    console.log(index, isChecked);
    newShareDetails[index].withoutPassword = isChecked;
    console.log(newShareDetails);
    setShareDetails(newShareDetails);
  };
  const handleCheckboxChange = (index, e) => {
    console.log(e.target.checked);
    const newShareDetails = [...shareDetails];
    newShareDetails[index].uploadAccess = e.target.checked;
    setShareDetails(newShareDetails);
  };

  const handleAccessTypeChange = (index, selectedOptions) => {
    console.log(index, selectedOptions);
    const newShareDetails = [...shareDetails];

    newShareDetails[index] = {
      ...newShareDetails[index],
      viewOnlyAccess: false,
      downloadAccess: false,
      uploadAccess: false,
    };

    // Set the selected access types to true
    selectedOptions.forEach((option) => {
      newShareDetails[index][option.value] = true;
    });

    setShareDetails(newShareDetails);
  };

  const handleTenantClick = async (index) => {
    SetSelectedTenant(index);
    setCreateFolder(true);
    console.log("tenant=-----first");
    console.log(index, "indedxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx");
    // const awsAccounts = index.awsAccounts.find((o) => o.isDefault === true);
    const awsAccounts = index.awsAccounts;

    console.log("Selected Tenant:", awsAccounts);
    const filteredBucket = awsAccounts[0].bucketList.filter((item) =>
      item.bucketName.includes("filemanager")
    );

    await handleBucketClick(filteredBucket[0]);
    setAwsId(awsAccounts[0].awsId);
    // setBuckets(filteredBucket);
    setshowTenant(false);
    setshowBucket(false);
    setshowFiles(false);
    // setCurrentView("bucket");
  };
  const handleBucketClick = async (bucketName) => {
    console.log("bucketclcik", bucketName);

    // Update selectedBucket first
    setSelectedBucket(bucketName);
    setBucketName(bucketName.bucketName);

    // Call fetchData after selectedBucket is updated
    fetchData("", bucketName, { _id: "" }).then(() => {
      setshowTenant(false);
      setshowBucket(false);
      setshowFiles(true);
      setCurrentView("folder");
    });
  };

  const handleReload = async () => {
    const data = {
      awsId,
      prefix: "",
      bucketName,
    };
    setLoading(true);
    try {
      const url = await awsService.reloadDb(data);
      console.log(url);
      if (url) {
        setCurrentView("tenant");
        setLoading(false);
        setCreateFolder(false);
        setshowTenant(true);
        setshowFiles(false);
        setshowBucket(false);

        if (url?.data?.code == 200) {
          toast.success("Items Fetched successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    } catch (error) {
      console.log(error);
      setLoading(false);

      toast.error("Failed to update the items!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleBackClick = () => {
    let prevItemId = "";
    setItemIdStack((prevStack) => {
      const newStack = [...prevStack];
      prevItemId = newStack.pop();
      if (!prevItemId) {
        setWriteAccess(false);
      }
      setItemId(prevItemId || "");
      if (prevItemId == undefined) {
        setshowTenant(true);
        setshowBucket(false);
        setshowFiles(false);
        return newStack;
      }
      return newStack;
      if (currentView != "tenant") {
        const data = fetchData(previousprefix, selectedBucket, {
          _id: prevItemId,
        }).then(() => {
          return true;
        });
        if (data) {
          return newStack;
        }
      } else if (prevItemId == undefined) {
        setshowTenant(true);
        setshowBucket(false);
        setshowFiles(false);
        return newStack;
      }
      // }
      setDropdownIndex(null);
    });

    if (currentView != "tenant") {
      const data = fetchData(previousprefix, selectedBucket, {
        _id: prevItemId,
      });
    }
    if (currentView === "folder") {
      // Navigate back to the bucket view
      const prevItemId = itemIdStack.pop();
      if (prevItemId == undefined) {
        setCurrentView("tenant");
        setWriteAccess(false);
        setshowTenant(true);
        setshowBucket(false);
        setshowFiles(false);
      } else {
        setshowTenant(false);
        setshowBucket(false);
        setshowFiles(true);
      }
      // setCurrentView("bucket");
      // setWriteAccess(false);
      // Fetch bucket data again (if needed)

      // fetchData(previousprefix, selectedBucket, { _id: ItemId });
    } else if (currentView === "bucket") {
      setshowTenant(true);
      setshowBucket(false);
      setshowFiles(true);
      setCurrentView("tenant");
      setSelectedBucket(null);
      setCurrentPrefix("");
      setCreateFolder(false);
      setWriteAccess(false);
    } else if (currentView === "file") {
      // Check if there's a parent folder to navigate back to
      if (currentPrefix) {
        const parts = currentPrefix.split("/");
        // Remove the last two parts to get the parent folder prefix
        const parentPrefix = parts.slice(0, -2).join("/");
        // Fetch data for the parent folder

        setshowTenant(false);
        setshowBucket(false);
        setshowFiles(true);
        setCurrentView("folder");
        setCreateFolder(false);
        setWriteAccess(true);
      } else {
        setCreateFolder(false);
        setWriteAccess(false);
        // If there's no parent folder, navigate back to the bucket view
        setshowTenant(true);
        setshowBucket(false);
        setshowFiles(false);
        // setCurrentView("bucket");
        setCurrentPrefix("");
        setWriteAccess(false);
        // Fetch bucket data again (if needed)
        // fetchData("", selectedBucket);
      }
    } else {
      // Default case, navigate to tenant view
      setCreateFolder(false);
      setWriteAccess(false);
      setshowTenant(true);
      setshowBucket(false);
      setshowFiles(false);
      setCurrentView("tenant");
      setSelectedBucket(null);
      setCurrentPrefix("");
      setWriteAccess(false);
    }
  };

  const observerCallback = (entries) => {
    for (let entry of entries) {
      if (entry.target === document.documentElement) {
        // console.log("Resize detected!");
        // Call your resize handling function here
      }
    }
  };

  // Create a new ResizeObserver
  const resizeObserver = new ResizeObserver(observerCallback);

  // Start observing the document's root element for resize events
  resizeObserver.observe(document.documentElement);

  const handleFileClick = async (item) => {
    try {
      setLoading(true);
      console.log(item);
      const fileType = item?.filename?.split(".").pop();
      let Types = ["png", "jpg", "jpeg", "gif", "mp4", "webm", "mp3", "wav"];

      if (Types.includes(fileType)) {
        const response = await awsService.PreviewUrl({
          Key: item.Key,
          id: item._id,
          awsId: awsId,
          bucketName: bucketName,
        });

        const url = URL.createObjectURL(response);

        setFileType(item.filename.split(".").pop());
        setLoading(false);

        setFileData(url);

        setFileModal(true);
      } else {
        handleDownloadlink(item);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleFileClose = async () => {
    setFileModal(false);
  };
  const renderFileContent = () => {
    if (
      fileType === "png" ||
      fileType === "jpg" ||
      fileType === "jpeg" ||
      fileType === "gif" ||
      fileType === "avif"
    ) {
      return <img src={fileData} alt="File content" />;
    }
    if (fileType === "mp4" || fileType === "webm") {
      return <video src={fileData} controls />;
    }
    if (fileType === "mp3" || fileType === "wav") {
      return <audio src={fileData} controls />;
    }

    return <p>Unsupported file type</p>;
  };

  const handleRenameFolder = async () => {
    setShowRenameFileModal(false);
    handleCreateFolder();
  };

  const handleCloseFolderRename = async () => {
    setShowRenameModal(false);
  };

  const handleCloseFileRename = async () => {
    setFolderName("");
    setitemRename({});
    setShowRenameFileModal(false);
  };

  function replaceSpacesWithUnderscores(str) {
    return str.replace(/\s+/g, "_");
  }

  return (
    <>
      <ToastContainer />{" "}
      <div
        className={`container-fluid mx-auto p-4 
    h-auto`}
      >
        <div className="flex justify-between items-center mb-4">
          <div className="flex space-x-2">
            {!showTenant && (
              <>
                <TooltipComponent content="Back" position="BottomCenter">
                  {" "}
                  <button
                    className={`text-gray-500 bg-transparent hover:bg-${
                      currentMode === "Dark" ? "gray-600" : "gray-100"
                    } rounded p-2 z-50`}
                    onClick={handleBackClick}
                    data-tooltip-id="back-tooltip"
                  >
                    <FaArrowLeft
                      className="mr-2"
                      style={{
                        fontSize: "1.3rem",
                        color: currentMode === "Dark" ? "#fff" : "",
                      }}
                    />
                  </button>
                </TooltipComponent>
                <TooltipComponent content="Home" position="BottomCenter">
                  <button
                    className={`text-gray-500 bg-transparent hover:bg-${
                      currentMode === "Dark" ? "gray-600" : "gray-100"
                    } rounded p-2 z-50`}
                    onClick={handleHomeClick}
                  >
                    <FaHome
                      className="mr-2"
                      style={{
                        fontSize: "1.5rem",
                        color: currentMode === "Dark" ? "#fff" : "",
                      }}
                    />
                    <Tooltip id="home-tooltip" place="bottom" effect="solid">
                      Home
                    </Tooltip>
                  </button>
                </TooltipComponent>
              </>
            )}
          </div>
          <div className="flex space-x-2">
            <div className="flex space-x-2">
              {(currentView == "file" || currentView == "folder") && (
                <TooltipComponent
                  content="  Fetch Data"
                  position="BottomCenter"
                >
                  <button
                    className={`text-gray-500 bg-transparent hover:bg-${
                      currentMode === "Dark" ? "gray-600" : "gray-100"
                    } rounded p-2 z-10`}
                    onClick={() => handleReload()}
                    data-tooltip-id="refresh-tooltip"
                  >
                    <FaSyncAlt
                      className="mr-2"
                      style={{
                        fontSize: "1.4rem",
                        color: currentMode === "Dark" ? "#fff" : "",
                      }}
                    />
                  </button>
                </TooltipComponent>
              )}
              {(currentView === "file" || currentView == "folder") && (
                <>
                  <TooltipComponent content="List View" position="BottomCenter">
                    <button
                      className={`text-gray-500 bg-transparent hover:bg-${
                        currentMode === "Dark" ? "gray-600" : "gray-100"
                      } rounded p-2`}
                      onClick={toggleListView}
                      data-tooltip-id="listView-tooltip"
                    >
                      <FaListUl
                        className="mr-2"
                        style={{
                          fontSize: "1.4rem",
                          color: currentMode === "Dark" ? "#fff" : "",
                        }}
                      />
                    </button>
                  </TooltipComponent>
                  <TooltipComponent content="Grid View" position="BottomCenter">
                    <button
                      className={`text-gray-500 bg-transparent hover:bg-${
                        currentMode === "Dark" ? "gray-600" : "gray-100"
                      } rounded p-2 z-10`}
                      onClick={toggleGridView}
                      data-tooltip-id="gridView-tooltip"
                    >
                      <IoGridOutline
                        className="mr-2"
                        style={{
                          fontSize: "1.4rem",
                          color: currentMode === "Dark" ? "#fff" : "",
                        }}
                      />
                    </button>
                  </TooltipComponent>
                </>
              )}
            </div>
            {createFolder && (
              <>
                <TooltipComponent
                  content=" Create Folder"
                  position="BottomCenter"
                >
                  <button
                    className="flex items-center justify-center px-2 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600 z-60"
                    style={{
                      backgroundColor: currentColor,
                      color: currentMode === "Dark" ? "#fff" : "",
                    }}
                    onClick={() => setFolderModal(true)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      />
                    </svg>
                  </button>
                </TooltipComponent>
              </>
            )}

            {writeAccess && (
              <>
                <TooltipComponent
                  content="  Create Folder or Upload File"
                  position="BottomCenter"
                >
                  <button
                    className="flex items-center justify-center px-2 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600"
                    style={{
                      backgroundColor: currentColor,
                      color: currentMode === "Dark" ? "#fff" : "",
                    }}
                    onClick={() => setShowModal(true)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      />
                    </svg>
                  </button>
                </TooltipComponent>
              </>
            )}
            {/* <Tooltip id="add-tooltip" place="top" effect="solid">
              Add Folder or Upload File
            </Tooltip> */}
          </div>
        </div>
        {/* <hr className="border-t border-gray-500 w-full " /> */}
        <div>
          {loading && (
            <Loading loading={"loading"} currentColor={currentColor} />
          )}
          {uploading && (
            <Loading loading={"uploading"} currentColor={currentColor} />
          )}
          {viewType === "grid" ? (
            <div>
              {showTenant && !showBucket && !showFiles && (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                  {tenants.map((item) => (
                    <div
                      onClick={() => handleTenantClick(item)}
                      key={item._id}
                      className={`p-4 rounded-lg shadow-md cursor-pointer  relative ${
                        currentMode === "Dark"
                          ? "text-white bg-[#33373E]"
                          : "bg-white  border-t-4 border-b-4 border-l border-r border-gray-300"
                      }`}
                      style={{ maxWidth: "400px" }}
                    >
                      <FaUsers
                        size={40}
                        className="mb-3"
                        style={{ color: currentColor }}
                      />
                      <h2
                        className="text-lg font-bold truncate w-full"
                        title={item.clientName}
                      >
                        {item.clientName}
                      </h2>
                    </div>
                  ))}
                </div>
              )}

              {!showTenant && showBucket && !showFiles && (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                  {buckets.map((item, index) => (
                    <div
                      onClick={() => {
                        handleBucketClick(item);
                      }}
                      key={index}
                      className={`p-4 rounded-lg shadow-md cursor-pointer relative ${
                        currentMode === "Dark"
                          ? "text-white bg-[#33373E]"
                          : "bg-white  border-t-4 border-b-4 border-l border-r border-gray-300"
                      }`}
                      style={{ maxWidth: "400px" }}
                    >
                      <GrStorage
                        size={40}
                        className="mb-3"
                        style={{ color: currentColor }}
                      />
                      <h2
                        className="text-lg font-bold truncate w-full"
                        title={item.bucketName}
                      >
                        {item.bucketName}
                      </h2>
                    </div>
                  ))}
                </div>
              )}

              {!showTenant && !showBucket && showFiles && (
                <div className="grid gap-4 grid-cols-[repeat(auto-fit,minmax(250px,390px))]">
                  {files?.map((item, index) => (
                    <div
                      onClick={() => {
                        if (item.Type === "folder") {
                          handleFolderClick(item.Prefix, selectedBucket, item);
                        } else if (item.Type === "file") {
                          handleFileClick(item);
                        }
                      }}
                      key={index}
                      className={`p-4 rounded-lg shadow-md cursor-pointer relative ${
                        currentMode === "Dark"
                          ? "text-white bg-[#33373E]"
                          : "bg-white  border-t-4 border-b-4 border-l border-r border-gray-300 "
                      }`}
                      
                    >
                      {item.Type === "folder" ? (
                        <>
                          <FaFolder
                            size={40}
                            className="mb-3"
                            style={{ color: currentColor }}
                          />
                          <h2
                            className="text-lg font-semibold truncate w-full"
                            title={item.newName}
                          >
                            {item.newName}
                          </h2>
                        </>
                      ) : (
                        <>
                          {["jpg", "png", "avif", "jpeg"].includes(
                            item.filename.split(".").pop().toLowerCase()
                          ) ? (
                            <FaRegFileImage
                              size={40}
                              className="mb-3"
                              style={{ color: currentColor }}
                              onClick={() => handleFileClick(item.Key)}
                            />
                          ) : (
                            <CiFileOn
                              size={50}
                              className="mb-3"
                              style={{ color: currentColor }}
                              onClick={() => handleFileClick(item.Key)}
                            />
                          )}
                          <h2
                            className="text-sm font-semibold truncate w-full"
                            title={item.newName}
                          >
                            {item.newName}
                          </h2>
                        </>
                      )}
                      {showSharebutton && (
                        <div className="absolute top-0 right-0 mt-2 mr-2">
                          <div className="relative">
                          <button
                              className="text-xl"
                              style={{
                                color: currentMode === "Dark" ? "white" : "gray",
                                width: "29px",
                                borderRadius: "20px",
                                background: "#f3f3f3",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleDropdown(index);
                              }}
                            >
                              &#8942;
                            </button>
                            <div>
                              {" "}
                              {dropdownIndex === index && (
                                <div
                                  ref={dropdownRef}
                                  className="absolute right-0 mt-2 bg-white shadow-lg rounded-lg z-10"
                                  // ref={modalRef}
                                >
                                  <button
                                    className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleShare(item);
                                    }}
                                    style={{ width: "100%" }}
                                  >
                                    Share
                                  </button>
                                  <button
                                    className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDownload(item);
                                    }}
                                  >
                                    Download
                                  </button>

                                  {item.Type == "file" && (
                                    <>
                                      <button
                                        className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDownloadlink(item);
                                        }}
                                        style={{ width: "100%" }}
                                      >
                                        Download Link
                                      </button>
                                      <button
                                        className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleRenameFile(item);
                                        }}
                                        style={{ width: "100%" }}
                                      >
                                        Rename
                                      </button>
                                      <button
                                        className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDeleteFileModal(item);
                                        }}
                                        style={{ width: "100%" }}
                                      >
                                        Delete
                                      </button>
                                    </>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <div>
              {showTenant && !showBucket && !showFiles && (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                  {tenants.map((item) => (
                    <div
                      onClick={() => handleTenantClick(item)}
                      key={item._id}
                      className={`p-4 rounded-lg shadow-md cursor-pointer  relative ${
                        currentMode === "Dark"
                          ? "text-white bg-[#33373E]"
                          : "bg-white  border-t-4 border-b-4 border-l border-r border-gray-300"
                      }`}
                      style={{ maxWidth: "400px" }}
                    >
                      <FaUsers
                        size={40}
                        className="mb-3"
                        style={{ color: currentColor }}
                      />
                      <h2
                        className="text-lg font-bold truncate w-full"
                        title={item.clientName}
                      >
                        {item.clientName}
                      </h2>
                    </div>
                  ))}
                </div>
              )}

              {!showTenant && showBucket && !showFiles && (
                <div className="">
                  {buckets.map((item, index) => (
                    <div
                      onClick={() => {
                        handleBucketClick(item);
                      }}
                      key={index}
                      className={`p-4 rounded-lg shadow-md cursor-pointer relative ${
                        currentMode === "Dark"
                          ? "text-white bg-[#33373E]"
                          : "bg-white  border-t-4 border-b-4 border-l border-r border-gray-300"
                      }`}
                    >
                      <GrStorage
                        size={40}
                        className="mb-3"
                        style={{ color: currentColor }}
                      />
                      <h2
                        className="text-lg font-bold truncate w-full"
                        title={item.bucketName}
                      >
                        {item.bucketName}
                      </h2>
                    </div>
                  ))}
                </div>
              )}

              {!showTenant && !showBucket && showFiles && (
                <div className="">
                  {files.map((item, index) => (
                    <div
                      onClick={() => {
                        if (item.Type === "folder") {
                          handleFolderClick(item.Prefix, selectedBucket, item);
                        } else if (item.Type === "file") {
                          handleFileClick(item);
                        }
                      }}
                      key={index}
                      className={`flex items-center shadow-md cursor-pointer bg-white p-2 relative mt-2 rounded-md ${
                        currentMode === "Dark"
                          ? "text-white bg-[#33373E]"
                          : "bg-white border-t-4 border-b-4 border-l border-r border-gray-300"
                      }`}
                      // style={{ maxWidth: "400px" }}
                    >
                      {item.Type === "folder" ? (
                        <>
                          <FaFolder
                            size={30}
                            className="mb-3"
                            style={{ color: currentColor }}
                          />
                          <h2
                            className="text-lg font-semibold truncate  ml-2"
                            title={item.newName}
                          >
                            {item.newName}
                          </h2>
                        </>
                      ) : (
                        <>
                          {["jpg", "png", "avif"].includes(
                            item.filename.split(".").pop().toLowerCase()
                          ) ? (
                            <FaRegFileImage
                              size={40}
                              className="mb-3"
                              style={{ color: currentColor }}
                              onClick={() => handleFileClick(item.Key)}
                            />
                          ) : (
                            <CiFileOn
                              size={50}
                              className="mb-3"
                              style={{ color: currentColor }}
                              onClick={() => handleFileClick(item.Key)}
                            />
                          )}
                          <h2
                            className="text-sm font-semibold truncate w-full"
                            title={item.newName}
                          >
                            {item.newName}
                          </h2>
                        </>
                      )}

                      {showSharebutton && (
                        <div className="ml-auto flex items-center">
                          {/* <TooltipComponent
                            content="share"
                            position="BottomCenter"
                          > */}
                          <span
                            className="ml-3"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleShare(item);
                            }}
                            style={{ cursor: "pointer", paddingRight: "10%" }}
                          >
                            <IoMdShareAlt
                              size={25}
                              color="gray"
                              style={{
                                color: currentMode === "Dark" ? "#fff" : "",
                              }}
                            />
                          </span>
                          {/* </TooltipComponent>
                          <TooltipComponent */}
                          {/* content="download"
                            position="BottomCenter"
                          > */}
                          <span
                            className="mr-4"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDownload(item);
                            }}
                            style={{ cursor: "pointer", paddingRight: "10%" }}
                          >
                            <MdDownload
                              size={25}
                              color="gray"
                              style={{
                                color: currentMode === "Dark" ? "#fff" : "",
                              }}
                            />
                          </span>
                          {/* </TooltipComponent> */}
                          {/* <span
                          onClick={() => handleDownload(item)}
                         style={{ cursor: "pointer" }}
                       >
                         <MdDownload
                           size={25}
                           color="gray"
                           style={{
                             color: currentMode === "Dark" ? "#fff" : "",
                           }}
                         />
                       </span> */}
                        </div>
                      )}

                      {/* {showSharebutton && (
                        <div className="absolute top-0 right-0 mt-2 mr-2">
                          <div className="relative">
                            <button
                              className="text-xl"
                              style={{
                                color:
                                  currentMode === "Dark" ? "white" : "gray",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleDropdown(index);
                              }}
                            >
                              &#8942;
                            </button>
                            <div>
                              {" "}
                              {dropdownIndex === index && (
                                <div
                                  ref={dropdownRef}
                                  className="absolute right-0 mt-2 bg-white shadow-lg rounded-lg z-10"
                                  // ref={modalRef}
                                >
                                  <button
                                    className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleShare(item);
                                    }}
                                    style={{ width: "100%" }}
                                  >
                                    Share
                                  </button>
                                  <button
                                    className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDownload(item);
                                    }}
                                  >
                                    Download
                                  </button>
                                  <button
                                    className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
                                    onClick={() => handleDownloadlink(item)}
                                  >
                                    Download Link
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )} */}
                    </div>
                  ))}
                </div>
              )}
            </div>

            // <div>
            //   {files.map((item, index) => (
            //     <React.Fragment key={index}>
            //       <div
            //         onClick={
            //           item.Type === "folder"
            //             ? () =>
            //                 handleFolderClick(item.Prefix, selectedBucket, item)
            //             : undefined
            //         }
            //         className={`flex items-center p-2 ${
            //           currentMode === "Dark" ? "text-white" : "bg-white"
            //         }`}
            //         style={{
            //           backgroundColor:
            //             currentMode === "Dark" ? "#33373E" : "white",
            //         }}
            //       >
            //         {item.Type === "folder" ? (
            //           <>
            //             <FaFolder
            //               size={30}
            //               className="mr-3 cursor-pointer"
            //               style={{ color: currentColor }}
            //             />
            //             <span className="flex-grow">
            //               {item.Prefix.split("/")
            //                 .filter((part) => part !== "")
            //                 .pop()}
            //             </span>
            //           </>
            //         ) : (
            //           <>
            //             {["jpg", "png", "avif"].includes(
            //               item.filename.split(".").pop().toLowerCase()
            //             ) ? (
            //               <FaRegFileImage
            //                 size={30}
            //                 className="mr-3 cursor-pointer"
            //                 style={{ color: currentColor }}
            //                 // onClick={() => handleFileClick(item.Key)}
            //               />
            //             ) : (
            //               <CiFileOn
            //                 size={30}
            //                 className="mr-3 cursor-pointer"
            //                 style={{ color: currentColor }}
            //                 // onClick={() => handleFileClick(item.Key)}
            //               />
            //             )}
            //             <span className="flex-grow">
            //               {item.filename}
            //               {/* {item.Key.substring(item.Key.lastIndexOf("-") + 1)} */}
            //             </span>
            //           </>
            //         )}
            //         <div className="ml-auto flex items-center">
            //           <span
            //             className="mr-3"
            //             onClick={() => handleShare(item)}
            //             style={{ cursor: "pointer" }}
            //           >
            //             <IoMdShareAlt
            //               size={25}
            //               color="gray"
            //               style={{
            //                 color: currentMode === "Dark" ? "#fff" : "",
            //               }}
            //             />
            //           </span>
            //           <span
            //             onClick={(e) => {
            //               e.stopPropagation();
            //               handleDownload(item);
            //             }}
            //             style={{ cursor: "pointer" }}
            //           >
            //             <MdDownload
            //               size={25}
            //               color="gray"
            //               style={{
            //                 color: currentMode === "Dark" ? "#fff" : "",
            //               }}
            //             />
            //           </span>
            //           {/* <span
            //             // onClick={() => handleDownload(item)}
            //             style={{ cursor: "pointer" }}
            //           >
            //             <MdDownload
            //               size={25}
            //               color="gray"
            //               style={{
            //                 color: currentMode === "Dark" ? "#fff" : "",
            //               }}
            //             />
            //           </span> */}
            //         </div>
            //       </div>
            //       {index !== files.length - 1 && (
            //         <div
            //           className="mx-2 border-b"
            //           style={{
            //             boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            //             backgroundColor:
            //               currentMode === "Dark" ? "#33373E" : "white",
            //           }}
            //         ></div>
            //       )}
            //     </React.Fragment>
            //   ))}
            // </div>
          )}

          {showModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-lg p-6 relative">
                <button
                  className="absolute top-0 right-0 p-2 text-gray-500 bg- hover:text-gray-700"
                  onClick={() => setShowModal(false)}
                >
                  <FaTimes />
                </button>
                <div className="flex justify-around">
                  <button
                    className=" px-4 py-2 rounded"
                    onClick={() => {
                      setFolderName("");
                      setFolderModal(true);
                      setShowModal(false);
                    }}
                  >
                    <FaFolder
                      size={50}
                      className="mb-3 "
                      style={{ color: currentColor }}
                    />
                    Create Folder
                  </button>
                  <label className=" px-4 py-2 rounded cursor-pointer">
                    <FaFile
                      size={50}
                      className="mb-3 "
                      style={{ color: currentColor }}
                    />
                    Upload File
                    <input
                      type="file"
                      className="hidden"
                      onChange={(e) => {
                        handleFileUpload(e);

                        setShowModal(false);
                      }}
                    />
                  </label>
                </div>
              </div>
            </div>
          )}

          {folderModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-lg p-6 relative">
                <button
                  className="absolute top-0 right-0 p-2 text-gray-500 hover:text-gray-700"
                  onClick={() => {
                    setLoading(false);
                    setFolderModal(false);
                  }}
                >
                  <FaTimes />
                </button>
                <div className="flex flex-col items-center">
                  <div>
                    <FaFolder
                      size={20}
                      className="mb-3"
                      style={{ color: currentColor }}
                    />
                    <input
                      type="text"
                      className="border border-gray-300 rounded px-4 py-2 mb-4 w-full"
                      placeholder="Enter folder name"
                      value={folderName}
                      onChange={(e) => setFolderName(e.target.value)}
                    />
                  </div>
                  <button
                    className="px-4 py-2 rounded bg-blue-500 text-white hover:bg-blue-700"
                    onClick={handleCreateFolder}
                    style={{ backgroundColor: currentColor }}
                  >
                    Create Folder
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        <Modal
          show={showShareModal}
          size="lg"
          onHide={() => setShowShareModal(false)}
          backdrop="static"
          keyboard={false}
          dialogClassName="modal-90h"
          className="modal-dialog-centered modal-90h"
        >
          <Modal.Header className="bg-white border-b border-gray-300">
            <div className="text-xl font-semibold text-gray-600">Share</div>
            <Button
              variant="light"
              onClick={() => setShowShareModal(false)}
              className="ml-auto bg-transparent text-gray-700 hover:text-gray-900 p-2 rounded-full"
              // data-tooltip-id="close-tooltip"
            >
              <FaTimes color="gray" />
            </Button>
            {/* <Tooltip id="close-tooltip" place="top" effect="solid">
              Close
            </Tooltip> */}
          </Modal.Header>
          <Modal.Body className="p-6 overflow-auto max-h-96">
            <Form>
              {shareDetails.map((shareDetail, index) => (
                <div key={index} className="mb-6">
                  <Form.Group controlId={`formExpiryDate${index}`}>
                    <div className="flex items-center justify-between space-x-4">
                      <div className="flex flex-col">
                        <label className="block text-base font-medium text-gray-700 mb-2">
                          Expiry Date
                        </label>
                        <div className="flex items-center border border-gray-300 rounded-lg p-2 flex-grow">
                          <FaCalendarAlt className="text-gray-500 mx-2" />
                          <DatePicker
                            minDate={subDays(new Date(), 0)}
                            selected={shareDetail.expiryDate}
                            onChange={(date) =>
                              handleExpiryDateChange(index, date)
                            }
                            dateFormat="P" // Use "P" to format the date without time
                            placeholderText="Select expiry date"
                            className="w-full px-2 py-0.5 rounded-lg outline-none"
                            style={{ border: "none" }}
                          />
                        </div>
                      </div>
                      <div className="flex-grow">
                        <div className="flex flex-col">
                          <label className="block text-base font-medium text-gray-700 mb-2">
                            Access level
                          </label>

                          <Select
                            key={index}
                            options={options}
                            isMulti
                            placeholder="Select access type"
                            classNamePrefix="react-select"
                            value={options.filter(
                              (option) => shareDetail[option.value]
                            )}
                            onChange={(selected) =>
                              handleAccessTypeChange(index, selected)
                            }
                            styles={customStyles}
                          />
                        </div>
                      </div>
                      <Button
                        className="ml-4  mt-4 flex items-center justify-center px-4 py-2 text-white rounded-full hover:bg-opacity-90"
                        style={{
                          backgroundColor: currentColor,
                          border: "none",
                        }}
                        onClick={onSubmit}
                      >
                        Share
                      </Button>
                    </div>

                    <div className="mt-3">
                      <Form.Check
                        type="checkbox"
                        id={`passwordProtection${index}`}
                        label="Protect with password"
                        checked={!shareDetail.withoutPassword}
                        onChange={(e) =>
                          handlePasswordProtectionChange(
                            index,
                            !e.target.checked
                          )
                        }
                        className="mb-2"
                      />
                    </div>
                    {/* <Form.Check
                      type="checkbox"
                      label={`Grant upload access`}
                      checked={shareDetail.uploadAccess}
                      onChange={(e) => handleCheckboxChange(index, e)}
                      className="mt-2"
                    /> */}
                  </Form.Group>
                </div>
              ))}
            </Form>
            <SharedLinks sharedLink={sharedLink} keys="share" />
          </Modal.Body>
          <Modal.Footer
            className="flex justify-end "
            style={{ borderTop: "none" }}
          ></Modal.Footer>
        </Modal>

        <Modal
          show={showShareLinkModal}
          onHide={() => setShowShareLinkModal(false)}
          backdrop="static"
          keyboard={false}
          className="modal-dialog-centered"
        >
          <Modal.Header className="bg-white border-b border-gray-300">
            <div className="text-xl font-semibold text-gray-600">Share</div>
            <Button
              variant="light"
              onClick={() => setShowShareLinkModal(false)}
              className="ml-auto bg-transparent text-gray-700 hover:text-gray-900 p-2 rounded-full"
              // data-tooltip-id="close-tooltip"
            >
              <FaTimes color="gray" />
            </Button>
          </Modal.Header>
          <Modal.Body className="p-6 overflow-auto">
            <Form>
              <Box
                component="form"
                sx={{
                  "& .MuiTextField-root": { m: 1 },
                }}
                noValidate
                autoComplete="off"
              >
                <div className="flex mb-3">
                  <div className="flex-1 mr-2">
                    <TextField
                      label="Share Link"
                      value={shareLink}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => copyToClipboard(shareLink, "link")}
                            >
                              {copiedLink ? (
                                <FaCheck
                                  size={18}
                                  style={{ color: currentColor }}
                                />
                              ) : (
                                <FaCopy
                                  size={18}
                                  style={{ color: currentColor }}
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </div>
                {sharePassword &&  <div className="flex-shrink-0 w-1/3">
                    <TextField
                      label="Password"
                      value={sharePassword}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                copyToClipboard(sharePassword, "password")
                              }
                            >
                              {copiedPassword ? (
                                <FaCheck
                                  size={18}
                                  style={{ color: currentColor }}
                                />
                              ) : (
                                <FaCopy
                                  size={18}
                                  style={{ color: currentColor }}
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </div>}
                </div>
              </Box>
            </Form>
          </Modal.Body>
          <Modal.Footer className="bg-gray-200 border-t border-gray-300 flex justify-end">
            <button></button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showCopyReplaceModal}
          onHide={() => setShowCopyReplaceModal(false)}
          backdrop="static"
          keyboard={false}
          className="modal-dialog-centered"
        >
          <Modal.Header className="bg-white border-b border-gray-300">
            {/* <div class="p-3 mb-2 bg-warning text-dark">File name already exists. Copy or Replace</div> */}
            <div className="text-xl font-semibold text-gray-600">
              Rename or Replace
            </div>
            <Button
              variant="light"
              onClick={() => setShowCopyReplaceModal(false)}
              className="ml-auto bg-transparent text-gray-700 hover:text-gray-900 p-2 rounded-full"
            >
              <FaTimes color="gray" />
            </Button>
          </Modal.Header>
          <Modal.Body className="p-6 overflow-auto">
            <Form>
              <Box
                component="form"
                sx={{
                  "& .MuiTextField-root": { m: 1 },
                }}
                noValidate
                autoComplete="off"
              >
                <div className="flex mb-3">
                  <div className="flex-1 mr-2">
                    <input
                      type="text"
                      placeholder="Filename"
                      value={copyFilename}
                      onChange={(e) => setcopyFilename(e.target.value)}
                      className="form-control"
                    />
                  </div>
                </div>
              </Box>
            </Form>
          </Modal.Body>
          <Modal.Footer className="bg-gray-200 border-t border-gray-300 flex justify-end">
            <Button
              variant="primary"
              onClick={() => {
                // Implement the copy functionality here
                console.log("Copy clicked");
                setShowCopyReplaceModal(false);
                handleCopyUpload();
              }}
              className="mr-2"
            >
              Rename
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                // Implement the replace functionality here
                console.log("Replace clicked");
                setShowCopyReplaceModal(false);
                handleReplaceUpload();
              }}
            >
              Replace
            </Button>
          </Modal.Footer>
        </Modal>

        <Rename
          title={"Folder already Exits. Please enter new name"}
          showmodal={renameModal}
          handleClose={handleCloseFolderRename}
          handleSubmit={handleRenameFolder}
          setName={setFolderName}
          Name={folderName}
        />

        <Rename
          title={"Enter new name to rename a file"}
          showmodal={renameFileModal}
          handleClose={handleCloseFileRename}
          handleSubmit={handlefileRenameSubmit}
          setName={setFolderName}
          Name={folderName}
        />
        <FileViewer
          showModal={fileModal}
          onClose={handleFileClose}
          renderFileContent={renderFileContent}
        />

        {fileDelete && (
          <DeleteConfirmationModal
            uidToDelete={itemDelete._id}
            onClose={handleCloseFileDelete}
            onDelete={handleFileDelete}
          />
        )}
      </div>
    </>
  );
};

export default S3FileManager;
